// Validación de RUT chileno
export const validateRut = (rut) => {
  if (!rut) return false;
  
  let rutLimpio = rut.replace(/[^0-9kK]/g, '');
  let dv = rutLimpio.slice(-1).toUpperCase();
  let rutNumero = parseInt(rutLimpio.slice(0, -1));
  
  let suma = 0;
  let multiplicador = 2;
  
  while (rutNumero > 0) {
    suma += (rutNumero % 10) * multiplicador;
    rutNumero = Math.floor(rutNumero / 10);
    multiplicador = multiplicador === 7 ? 2 : multiplicador + 1;
  }
  
  let dvEsperado = 11 - (suma % 11);
  dvEsperado = dvEsperado === 11 ? '0' : dvEsperado === 10 ? 'K' : dvEsperado.toString();
  
  return dv === dvEsperado;
};

// Formatear RUT mientras se escribe
export const formatRut = (value) => {
  // Eliminar caracteres no válidos
  let rut = value.replace(/[^0-9kK]/g, '');
  
  // Si está vacío, retornar
  if (rut.length === 0) return '';
  
  // Obtener dígito verificador
  const dv = rut.slice(-1);
  let rutNumber = rut.slice(0, -1);
  
  // Formatear número
  rutNumber = rutNumber.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
  return rutNumber + '-' + dv;
};

// Validación de email
export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email.toLowerCase());
};

// Validación de contraseña
export const validatePassword = (password) => {
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*]/.test(password);
  
  return password.length >= minLength && 
         hasUpperCase && 
         hasLowerCase && 
         hasNumbers && 
         hasSpecialChar;
};

// Validación de nombre
export const validateName = (name) => {
  if (!name) return false;
  const re = /^[a-záéíóúüñÁÉÍÓÚÜÑ\s]{2,50}$/i;
  return re.test(name.trim());
};

// Obtener requisitos de contraseña
export const getPasswordRequirements = (password) => {
  return [
    {
      text: 'Al menos 8 caracteres',
      met: password.length >= 8
    },
    {
      text: 'Al menos una letra mayúscula',
      met: /[A-Z]/.test(password)
    },
    {
      text: 'Al menos una letra minúscula',
      met: /[a-z]/.test(password)
    },
    {
      text: 'Al menos un número',
      met: /\d/.test(password)
    },
    {
      text: 'Al menos un carácter especial (!@#$%^&*)',
      met: /[!@#$%^&*]/.test(password)
    }
  ];
};

// Validar formulario completo
export const validateForm = (formData) => {
  const errors = {};

  if (!validateName(formData.nombre)) {
    errors.nombre = 'El nombre debe contener solo letras y tener entre 2 y 50 caracteres';
  }

  if (!validateName(formData.apellidos)) {
    errors.apellidos = 'Los apellidos deben contener solo letras y tener entre 2 y 50 caracteres';
  }

  if (!validateEmail(formData.email)) {
    errors.email = 'El formato del email no es válido';
  }

  if (!validatePassword(formData.password)) {
    errors.password = 'La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial';
  }

  if (formData.password !== formData.confirmPassword) {
    errors.confirmPassword = 'Las contraseñas no coinciden';
  }

  if (!validateRut(formData.rut)) {
    errors.rut = 'El formato o dígito verificador del RUT no es válido';
  }

  if (!formData.aceptaTerminos) {
    errors.aceptaTerminos = 'Debes aceptar los términos y condiciones';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
}; 